export default {
  systemloadminute: "Загрузка системы в течение 1 минуты",
  systemloadfiveminute: "Загрузка системы в течение 5 минут",
  systemloadquarterminute: "Загрузка системы в течение 15 минут",
  charging: "Идёт зарядка",
  cleanwatertank: "Бак чистой воды",
  bilgetank: "Бак сточных вод",
  malfunction: "В состоянии неисправности",
  positioningfailed: "Сбой позиционирования",
  datarequestfailed: "Ошибка запроса данных, повторите попытку",
  CPUusagerate: "Показатель использования ЦП",
  physicalusagerate: "Показатель использования физической памяти",
  recordbag: "Запись Bag-файла",
  recording: "Идёт запись",
  recorded: "Запись успешно завершена",
  recordfailed: "Ошибка записи, повторите попытку",
  networkread: "Онлайн-чтение (КБИТ/с)",
  networkwrite: "Запись по сети (КБИТ/с)",
  diskread: "Чтение диска (КБИТ/с)",
  diskwrite: "Запись на диск (КБИТ/с)",
  restart: "Перезагрузка",
  speed: "Скорость автомобиля",
  rollingbrushpressure: "Давление валика",
  rollingbrushspeed: "Скорость вращения валика",
  edgebrushspeed: "Скорость вращения боковой щётки",
  watercapacity: "Объём распыления воды",
  bibulouscrouching: "Водосъёмник",
  suctionlevel: "Уровень всасывания",
  edgebrushpressure: "Давление боковой щётки",
  dustmop: "Сухая швабра / пылесборник",
  detergentconcentration: "Концентрация моющего средства",
  cleaningmode: "Режим уборки",
  snap: "Снимок",
  snaping: "Идёт съёмка",
  snaped: "Снимок успешно сделан",
  snaprecorde: "Запись снимков",
  serialnumber: "Порядковый номер",
  vin: "VIN",
  capturetime: "Время съёмки",
  operate: "Операция",
  view: "Просмотр",
  supplying: "Идёт пополнение",
  autosupplying: "Идёт автоматическое пополнение",
  starttime: "Время начала",
  station: "Рабочая станция",
  supplymode: "Режим пополнения",
  fullsupply: "Полное пополнение",
  chargeonly: "Только зарядка",
  rollingbrushrotation: "Вращение валика",
  deny: "Нет",
  yes: "Да",
  rollbrushposition: "Положение валика",
  lift: "Поднять",
  putdown: "Опустить",
  edgebrushrotation: "Вращение боковой щётки",
  edgebrushposition: "Положение боковой щётки",
  suctionposition: "Положение водосъёмника",
  suctionon: "Всасывание включено",
  close: "Закрыть",
  open: "Открыть",
  wateringon: "Полив включён",
  time: "Время",
  faultdiagnosis: "Диагностика неисправностей",
  faultlist: "Список неисправностей",
  adaptationcode: "Код адаптации",
  firstactivationtime: "Время первой активации",
  selectactivationtime: "Пожалуйста, выберите время первой активации",
  sitename: "Название площадки",
  sitetype: "Тип площадки",
  agentname: "Название агента",
  sitelocation: "Расположение площадки",
  operatorname: "Имя оператора",
  operatorphone: "Телефон оператора",
  adaptationtime: "Время адаптации",
  savetime: "Успешно сохранено",
  operater: "Эксплуатация",
  labelmanagement: "Управление метками",
  edit: "Редактировать",
  add: "Добавить",
  label: "Метка",
  labelname: "Название метки",
  inputlablename: "Пожалуйста, введите название метки",
  labelnameduplicated: "Название метки дублируется",
  labeltype: "Тип метки",
  selectlabeltype: "Пожалуйста, выберите тип метки",
  cartype: "Модель автомобиля",
  car: "Транспортное средство",
  batchimport: "Пакетный импорт",
  addedvehicle: "Транспортные средства добавлены",
  common: "Всего",
  vehicle: "шт.",
  submit: "Отправить",
  enduser: "конечный пользователь",
  cancellation: "Отмена",
  selectcar: "Пожалуйста, выберите транспортное средство",
  determine: "Подтвердить",
  inputvalidation:
    "Вставьте или введите текст с VIN. Поддерживаются разделители: пробел, перенос строки, запятая",
  verificationprompt:
    "Подсказка: другие разделители можно заменить на указанные с помощью функции «Найти и заменить»",
  importfailed: "Импорт не удался",
  vinabsent:
    "У следующих транспортных средств отсутствует VIN. Проверьте и повторите попытку",
  vehicleabsent:
    "Модель следующих транспортных средств не совпадает. Проверьте и повторите попытку",
  commonlabel: "Обычная метка",
  createdsuccessfully: "Создано успешно",
  creationfailed: "Ошибка создания",
  labelempty: "Название метки не может быть пустым",
  pleaseaddcar: "Пожалуйста, добавьте транспортное средство",
  imported: "Транспортные средства успешно импортированы",
  set: "Настройки",
  usermanage: "Управление пользователями",
  user: "Пользователь",
  username: "Имя пользователя",
  tel: "Номер телефона",
  role: "Роль",
  selectrole: "Пожалуйста, выберите роль",
  loginpassword: "Пароль входа",
  confirmpassword: "Подтвердите пароль",
  inputusername: "Введите имя пользователя",
  inputtel: "Введите номер телефона",
  inputpassword: "Введите пароль",
  added: "Успешно добавлено",
  edited: "Успешно отредактировано",
  inputrighttel: "Введите корректный номер телефона",
  passwordinputsinconsistent: "Пароли не совпадают",
  customermanagement: "Управление клиентами",
  listofagents: "Список агентов",
  supportproxy: "Поддержка поиска по агенту / региону",
  search: "Поиск",
  newagent: "Создать агента",
  agentarea: "Регион агента",
  pleaseselct: "Пожалуйста, выберите",
  founder: "Создатель",
  creationtime: "Время создания",
  save: "Сохранить",
  inputonly: "Можно вводить только",
  character: "символов",
  parametername: "Название параметра",
  parametervalue: "Значение параметра",
  parameterrange: "Диапазон параметра",
  unit: "Единица измерения",
  plan: "Планирование",
  safedistance: "Безопасное расстояние",
  outermostcircleoptimization: "Оптимизация внешнего контура",
  routespacing: "Расстояние между маршрутами",
  cleaningwidth: "Ширина уборки",
  supplementarynumbers: "Количество дополнительных проходов",
  missedscanthreshold: "Порог пропущенных участков",
  planningmode: "Режим планирования (обычный / агрессивный / консервативный)",
  supplystationsandpiles: "Порог коррекции расстояния до станции пополнения",
  positioning: "Позиционирование",
  largeramps: "Присутствуют ли в сцене крутые склоны",
  fullprocessrecording:
    "Записывать ли IMU, скорость колёс и лазерные данные в процессе построения карты",
  kfhighresolutionndt:
    "Порог детекции петель на основе KF, высокое разрешение NDT",
  kfsmalresolutionndt:
    "Порог детекции петель на основе KF, низкое разрешение NDT",
  submapsmalresolutionndt:
    "Порог детекции петель на основе submap, низкое разрешение NDT",
  longcorridorthreshold: "Порог деградации в длинных коридорах",
  opensquarethreshold: "Порог деградации на открытых площадях",
  lasertoDRweightratio: "Соотношение весов лазера и DR",
  anglesearch: "Диапазон поиска угла при инициализации",
  locationsearch: "Диапазон поиска позиции при инициализации",
  meandistance: "Порог среднего расстояния при инициализации",
  effectivepointratio: "Порог доли валидных точек при инициализации",
  drmaximumestimatedtime: "Максимальное время экстраполяции DR",
  drmaximumestimateddistance: "Максимальное расстояние экстраполяции DR",
  anglecorrectionswitchfordr: "Переключатель коррекции угла для DR",
  perception: "Восприятие",
  istheblackobstacledetectionmoduleenabled:
    "Включён ли модуль обнаружения чёрных препятствий",
  minimumheightfordetectinggroundobstacles:
    "Минимальная высота для обнаружения наземных препятствий",
  bagmanagement: "Управление Bag-файлами",
  pleaseenterthevin: "Введите VIN",
  pleaseselectastatus: "Выберите статус",
  pleaseselectatype: "Выберите тип",
  vehiclemodel: "Модель транспортного средства",
  onlineornot: "Онлайн или нет",
  online: "Онлайн",
  notonline: "Не в сети",
  registrationtime: "Время регистрации",
  carendbag: "Bag-пакет с транспортного средства",
  cloudbagpackage: "Bag-пакет из облака",
  vehiclemanagement: "Управление транспортными средствами",
  vehiclelist: "Список транспортных средств",
  vehicleinformation: "Информация о транспортном средстве",
  vehiclestatus: "Состояние транспортного средства",
  electricitylevel: "Уровень заряда",
  basicinformation: "Базовая информация",
  vehiclearchitecture: "Архитектура транспортного средства",
  vehiclename: "Название транспортного средства",
  modify: "Изменить",
  lastonlinetime: "Последнее время в сети",
  simcardiccid: "ICCID SIM-карты",
  adminpassword: "Пароль администратора",
  reset: "Сброс",
  userpassword: "Пароль пользователя",
  versioninformation: "Информация о версии",
  softwareversion: "Версия ПО",
  hardwareversion: "Версия оборудования",
  historicalstatus: "История состояний",
  locationdata: "Данные о местоположении",
  boardinformation: "Информация о платах",
  operationinformation: "Информация о работе",
  batterydata: "Данные аккумулятора",
  accessoriesdata: "Данные о комплектующих",
  faultinformation: "Информация о неисправностях",
  datastatistics: "Статистика данных",
  adaptationrecord: "Журнал адаптаций",
  resetting: "Выполняется сброс",
  resetsuccessful: "Сброс выполнен успешно",
  totalvoltageofbatterypack: "Общее напряжение аккумуляторной батареи",
  totalcurrentofbatterypack: "Общий ток аккумуляторной батареи",
  batterystatus: "Состояние аккумулятора",
  batterychargingremainingtime: "Оставшееся время зарядки",
  charginglinelinkstatus: "Состояние подключения зарядного кабеля",
  bmswarninglevel: "Уровень предупреждения BMS",
  recordtime: "Время записи",
  clean: "Уборка",
  supplementaryscanningswitch: "Переключатель дополнительной уборки",
  dustpushsuctioninterval:
    "Интервал между режимами «пылесборник» и «всасывание»",
  dustpushingandsuctioncycle: "Цикл «пылесборник + всасывание»",
  watercollectionoperation: "Операция сбора воды",
  swipetime: "Время отжима щётки",
  forwardsuctiontime: "Время всасывания при движении вперёд",
  parkingwaterabsorptiontime: "Время всасывания на месте",
  parkingsuctiontime: "Время всасывания на месте",
  distancetoliftthemoduleinfrontofthefunctionalarea:
    "Расстояние до подъёма модуля перед функциональной зоной",
  waterstopdistanceinfrontofthefunctionalarea:
    "Расстояние до отключения воды перед функциональной зоной",
  functionalareaparkingandwaterabsorptiontime:
    "Время всасывания на месте в функциональной зоне",
  alignmenttimes: "Количество попыток выравнивания",
  delayeddrainagetime: "Время задержки слива",
  task: "Задача",
  automaticfillingclosedloop: "Автоматическое замкнутое пополнение",
  taskinitiationscope: "Диапазон запуска задачи",
  automaticreturntodockingpoint: "Автоматический возврат на стоянку",
  other: "Прочее",
  dormancy: "Режим сна",
  voicebroadcastrepetitioninterval: "Интервал повтора голосового оповещения",
  mappingaccuracy: "Точность построения карты",
  synchronousvehicleendbag: "Синхронизация Bag-пакета с транспортного средства",
  bagpackagename: "Название Bag-пакета",
  uploadstatus: "Статус загрузки",
  bagpackagerecordingmethod: "Метод записи Bag-пакета",
  recordreasons: "Причина записи",
  size: "Размер",
  upload: "Загрузить",
  carendfaultpackageupload:
    "Загрузка пакета неисправностей с транспортного средства",
  uploadcompleted: "Загрузка завершена",
  uploading: "Идёт загрузка",
  uploadfailed: "Ошибка загрузки",
  deleting: "Удаление",
  successfullydeleted: "Успешно удалено",
  deletefailed: "Ошибка удаления",
  singlecardatastatistics: "Статистика по одному транспортному средству",
  timefiltering: "Фильтр по времени",
  endtime: "Время окончания",
  tasktype: "Тип задачи",
  statisticaldatadownload: "Скачать статистику",
  taskname: "Название задачи",
  cleaningfrequency: "Количество уборок",
  taskstarttime: "Время начала задачи",
  taskendtime: "Время окончания задачи",
  cleaningtime: "Время уборки",
  waterconsumption: "Расход воды",
  electricityconsumptionkwh: "Потребление электроэнергии (кВт·ч)",
  plannedcleaningaream2: "Планируемая площадь уборки (м²)",
  actualcleaningaream2: "Фактическая площадь уборки (м²)",
  uncleanedaream2: "Неубранная площадь (м²)",
  cleaningefficiencyh: "Эффективность уборки (м²/ч)",
  operator: "Оператор",
  scheduledtasks: "Запланированные задачи",
  details: "Подробности",
  whole: "Все",
  minute: "Минута",
  hour: "Час",
  singlecardatadetails: "Детали данных по одному транспортному средству",
  combinedtasks: "Комбинированные задачи",
  multifloortasks: "Многоэтажные задачи",
  mapname: "Название карты",
  cleaningefficiency: "Эффективность уборки",
  taskcompletionrate: "Процент выполнения задачи",
  electricityconsumption: "Потребление электроэнергии",
  supplyfrequency: "Количество пополнений",
  export: "Экспорт",
  combinationtaskname: "Название комбинированной задачи",
  plannedcleaningarea: "Планируемая площадь уборки",
  actualcleaningarea: "Фактическая площадь уборки",
  uncleanedarea: "Неубранная площадь",
  memoryusagerate: "Использование памяти",
  diskusagerate: "Использование диска",
  averageloadrate: "Средняя загрузка",
  accumulatedhomeworkdurationautomatichomework:
    "Общая продолжительность работы (автоматическая уборка)",
  accumulateddrivingdistanceautonomousdriving:
    "Общий пробег (автономное вождение)",
  accumulatedcleaningareaautomaticoperation:
    "Общая площадь уборки (автоматическая уборка)",
  vehiclespeedlow: "Низкая скорость",
  vehiclespeedmedium: "Средняя скорость",
  vehiclespeedhigh: "Высокая скорость",
  rollingbrushpressurelow: "Низкое давление валика",
  percentage: "Процент",
  rollingbrushpressuremedium: "Среднее давление валика",
  rollingbrushpressurehigh: "Высокое давление валика",
  rollingbrushspeedlow: "Низкая скорость вращения валика",
  gearposition: "Передача",
  rollingbrushspeedmedium: "Средняя скорость вращения валика",
  rollingbrushspeedhigh: "Высокая скорость вращения валика",
  edgebrushspeedlow: "Низкая скорость вращения боковой щётки",
  edgebrushspeedmedium: "Средняя скорость вращения боковой щётки",
  edgebrushspeedhigh: "Высокая скорость вращения боковой щётки",
  watersprayvolumelow: "Низкий объём распыления воды",
  watersprayvolumemedium: "Средний объём распыления воды",
  watersprayvolumehigh: "Высокий объём распыления воды",
  suctionlevellow: "Низкий уровень всасывания",
  suctionlevelmedium: "Средний уровень всасывания",
  suctionlevelhigh: "Высокий уровень всасывания",
  filesize: "Размер файла",
  uploadtime: "Время загрузки",
  download: "Скачать",
  fixedareahasnotbeendrivenoutforalongtime:
    "Долгое время не покидалась фиксированная зона",
  longtermparking: "Длительная стоянка",
  positioninginitializationsuccessful: "Инициализация позиционирования успешна",
  positioninginitializationfailed: "Ошибка инициализации позиционирования",
  positioninglasermismatch:
    "Несоответствие лазерных данных при позиционировании",
  locationloss: "Потеря позиционирования",
  firstlevelfault: "Неисправность 1-го уровня",
  designatedfaults: "Указанные неисправности",
  failuretoextricateoneselffromdifficulties:
    "Не удалось выйти из затруднительного положения",
  deviationpath: "Отклонение от маршрута",
  globalpathplanningfailed: "Ошибка глобального планирования маршрута",
  collisionoccurs: "Произошло столкновение",
  taskmanagement: "Управление задачами",
  scheduledtaskmonitoring: "Мониторинг запланированных задач",
  pleaseentervinmapnameortaskname: "Введите VIN, название карты или задачи",
  scheduledtaskname: "Название запланированной задачи",
  scheduledtaskstarttime: "Время начала запланированной задачи",
  appointmenttasktype: "Тип задания на бронирование",
  singlemaptimedtask: "Задача по одной карте",
  multifloortimedtasks: "Многоэтажная запланированная задача",
  scheduledtaskexecutionstatus: "Статус выполнения запланированной задачи",
  customerlist: "Список клиентов",
  customer: "Клиент",
  customername: "Название клиента",
  pleaseenterthecustomername: "Введите название клиента",
  customerphotos: "Фотографии клиента",
  uploadimages: "Загрузить изображения",
  uploadupto5images: "Можно загрузить до 5 изображений",
  picturepreview: "Предпросмотр изображения",
  workstationmode: "Режим рабочей станции",
  exclusivestake: "Эксклюзивная станция",
  sharedstake: "Общая станция",
  offlinepile: "Офлайн-станция",
  customeraddress: "Адрес клиента",
  pleaseenterthecustomeraddress: "Введите адрес клиента",
  customerremarks: "Примечания клиента",
  thesizeoftheuploadedfilecannotexceed1mb:
    "Размер файла не должен превышать 1 МБ",
  theimagemustbeinjpgorpngformat:
    "Изображение должно быть в формате JPG или PNG",
  customernamecannotbeemptyorblank:
    "Название клиента не может быть пустым или содержать только пробелы",
  customeraddresscannotbeemptyorblank:
    "Адрес клиента не может быть пустым или содержать только пробелы",
  only5imagescanbeuploaded: "Можно загрузить только 5 изображений",
  pleaseentercustomernamevehiclevinworkstationzin:
    "Введите название клиента / VIN транспортного средства / ZIN рабочей станции",
  newcustomer: "Создать клиента",
  vehiclevin: "VIN транспортного средства",
  workstationzin: "ZIN рабочей станции",
  workstationmanagement: "Управление рабочими станциями",
  mapmanagement: "Управление картами",
  supportvinsearch: "Поддержка поиска по VIN",
  numberofmaps: "Количество карт",
  lastupdatetime: "Последнее обновление",
  rawdatadownload: "Скачать исходные данные",
  numberoftasks: "Количество задач",
  tasktimeconsumption: "Время выполнения задачи",
  lowwatervolumethresholdforclearwater: "Порог низкого уровня чистой воды",
  highwastewatervolumethreshold: "Порог высокого уровня сточных вод",
  lowbatterythreshold: "Порог низкого заряда",
  filterstartthreshold: "Порог запуска фильтрации",
  chargingthreshold: "Порог зарядки",
  wateradditionthreshold: "Порог добавления воды",
  savefailedpleaseconfirmthevehiclenetworkstatus:
    "Ошибка сохранения. Проверьте сетевое подключение транспортного средства",
  elevatormanagement: "Управление лифтами",
  elevatoreditor: "Редактор лифтов",
  devicename: "Название устройства",
  elevatoruniqueidentification: "Уникальный идентификатор лифта",
  numberofelevatorfloors: "Количество этажей лифта",
  floorlist: "Список этажей",
  numberofboundvehicles: "Количество привязанных транспортных средств",
  bindvehiclelist: "Список привязанных транспортных средств",
  elevatorname: "Название лифта",
  manufacturername: "Название производителя",
  entryname: "Название проекта",
  buildinginformation: "Информация о здании",
  pleaseentertheelevatorname: "Введите название лифта",
  pleaseenterthevehiclevinlabelname:
    "Введите VIN транспортного средства или название метки",
  elevatorid: "ID лифта",
  pleaseentertheelevatorid: "Введите ID лифта",
  pleaseenteraprojectname: "Введите название проекта",
  faultlevel: "Уровень неисправности",
  pleaseselectthefaultlevel: "Выберите уровень неисправности",
  faultstatus: "Статус неисправности",
  pleaseselectthefaultstatus: "Выберите статус неисправности",
  faulttime: "Время неисправности",
  supportfaultnameandfaultcodesearch:
    "Поддержка поиска по названию и коду неисправности",
  datarefresh: "Обновление данных",
  downloadfaultpackagelist: "Скачать список пакетов неисправностей",
  faultcode: "Код неисправности",
  faultname: "Название неисправности",
  faultymodule: "Неисправный модуль",
  workingmode: "Режим работы",
  duration: "Продолжительность (с)",
  washmachine: "Система управления поломоечной машиной",
  exitprompt: "Подтверждение выхода",
  logout: "Выйти из системы?",
  supporttagvinsearch: "Поддержка поиска по метке / VIN",
  selectvehiclemodel: "Выберите модель транспортного средства",
  addlabels: "Добавить метки",
  carmodel: "Модель транспортного средства",
  numcar: "Количество транспортных средств",
  delete: "Удалить",
  deletedata: "Удалить выбранные данные?",
  deleteconfirmation: "Подтверждение удаления",
  confirm: "Подтвердить",
  password: "Пароль",
  login: "Войти",
  mapsize: "Размер карты",
  updatetime: "Время обновления",
  datareplication: "Копирование данных",
  createmapOTAtask: "Создать OTA-задачу для карты",
  updatedescription: "Описание обновления",
  gopublish: "Перейти к публикации",
  taskcreatedsuccessfully: "Задача успешно создана",
  publishedmap: "Выберите карту для публикации",
  supportphonenamesearch: "Поддержка поиска по номеру телефона / имени",
  batchdelete: "Пакетное удаление",
  selected: "Выбрано",
  term: "Элемент",
  agent: "Агент",
  customertype: "Тип пользователя",
  domesticusers: "Внутренние пользователи",
  internationalusers: "Международные пользователи",
  usercomments: "Примечания пользователя",
  resetpassword: "Сбросить пароль",
  selectphonenumber: "Выберите номер телефона пользователя",
  nouserselected: "Пользователь не выбран",
  passwordresetto: "Пароль сброшен на",
  otamanagement: "Управление OTA",
  mapversion: "Версия карты",
  versioning: "Управление версиями",
  otadetails: "Детали OTA",
  types: "Тип",
  filename: "Имя файла",
  version: "Номер версии",
  return: "Назад",
  enterversion: "Введите номер версии / автора",
  newversion: "Создать версию",
  addpeople: "Автор",
  release: "Опубликовать",
  deleteselecteddata: "Удалить выбранные данные?",
  mappublishing: "Публикация карты",
  releaserecords: "История публикаций",
  upgradeprogress: "Прогресс обновления",
  supportvintagname: "Поддержка поиска по VIN / названию метки",
  upgradestatus: "Статус обновления",
  currentversion: "Текущая версия",
  statusupdatetime: "Время обновления статуса",
  progressdetails: "Детали прогресса",
  suretoresendit: "Подтвердить повторную отправку?",
  reissue: "Повторная отправка",
  completedatvehicle:
    "Последующие действия нужно выполнить вручную на транспортном средстве",
  success: "Успешно",
  successfullyredistributed: "Повторная отправка успешна",
  withouttheneedtoresend:
    "После подключения транспортного средства система автоматически повторит попытку",
  pleasenotethat: "Обратите внимание",
  otarelease: "Публикация OTA",
  publicationtype: "Тип публикации",
  filesname: "Название файла",
  pushvehicle: "Отправить на транспортное средство",
  pleaseenterlabelvin: "Введите метку / VIN",
  byvehicle: "По транспортному средству",
  bylabel: "По метке",
  model: "Модель",
  pushvehiclelist: "Список транспортных средств для отправки",
  confirmationandrelease:
    "Подтвердить публикацию, несмотря на офлайн-транспортные средства",
  tryagain:
    "Модель транспортного средства не совпадает с пакетом. Проверьте и повторите попытку",
  donotmatch:
    "Архитектура транспортного средства не совместима с пакетом. Проверьте и повторите попытку",
  successfullypublished: "Успешно опубликовано",
  publishingfailed: "Ошибка публикации",
  automaticallyretry:
    "Следующие транспортные средства офлайн. OTA не отправлено. Повтор после подключения",
  otacreation: "Создание OTA",
  uploadfiles: "Загрузить файлы",
  startuploading: "Начать загрузку",
  schedule: "Прогресс",
  parsingfailed: "Ошибка разбора. Нажмите для повторной загрузки",
  tobeanalyzed: "Ожидает анализа",
  uploadapk: "Загрузить APK",
  enterversionnumber: "Введите номер версии",
  enterupdatedescription: "Введите описание обновления",
  fillinversionnumber: "Укажите номер версии",
  Incorrectversionformat: "Неверный формат номера версии",
  uploadsuccessful: "Загрузка успешна",
  uploadfaileds: "Ошибка загрузки. Повторите попытку",
  nonconformance: "Файл не соответствует требованиям",
  selectuploadedfile: "Сначала выберите файл для загрузки",
  uploadfileagain: "Вы сменили тип OTA. Загрузите файл заново",
  parametersettings: "Настройка параметров",
  regeneratetask: "Пересоздать задачу",
  devicethreshold: "Пороговые значения устройства",
  cleaningparameters: "Параметры уборки",
  serviceparameters: "Бизнес-параметры",
  autonomousdriving: "Автономное вождение",
  positioninglevel: "Уровень позиционирования",
  positioningsuccessful: "Позиционирование успешно",
  generalpositioning: "Среднее качество позиционирования",
  entervinversionpublisher: "Введите VIN / номер версии / публикатора",
  otatype: "Тип OTA",
  selectotatype: "Выберите тип OTA",
  publisher: "Публикатор",
  releasetime: "Время публикации",
  charactersettings: "Настройка ролей",
  enterrolename: "Введите название роли",
  newrole: "Создать роль",
  name: "Название роли",
  addfailed: "Ошибка добавления",
  editingfailed: "Ошибка редактирования",
  idle: "Простой",
  initializing: "Инициализация",
  shutdown: "Выключение",
  offline: "Офлайн",
  crashstop: "Аварийная остановка",
  fault: "Неисправность",
  manualdriving: "Ручное управление",
  forcedmanual: "Принудительное ручное управление",
  duringcleaning: "Идёт уборка",
  gotosupply: "Направляется на пополнение",
  gotodock: "Направляется на стоянку",
  entermapname: "Введите название задачи или карты",
  forcedendtime: "Время принудительного завершения",
  repetitionperiod: "Период повторения",
  week: "Неделя",
  customize: "Пользовательский режим",
  deepcleaning: "Глубокая уборка",
  dailycleaning: "Ежедневная уборка",
  silentcleaning: "Бесшумная уборка",
  rewashingmode: "Режим повторной уборки",
  energysavingmode: "Энергосберегающий режим",
  dustpushmode: "Режим сухой уборки",
  expectedendtime: "Ожидаемое время окончания",
  monday: "Пн",
  tuesday: "Вт",
  wednesday: "Ср",
  thursday: "Чт",
  friday: "Пт",
  saturday: "Сб",
  sunday: "Вс",
  securitysetting: "Настройки безопасности",
  basicinformations: "Основная информация",
  changepassword: "Изменить пароль",
  originalpassword: "Текущий пароль",
  enteroriginalpassword: "Введите текущий пароль",
  newpassword: "Новый пароль",
  enternewpassword: "Введите новый пароль",
  confirmnewpassword: "Подтвердите новый пароль",
  enternewpasswordagain: "Повторите новый пароль",
  successfullymodified: "Пароль успешно изменён",
  modificationfailed: "Ошибка изменения",
  passwordissame: "Новый пароль совпадает со старым",
  twicenotsame: "Пароли не совпадают",
  unattended: "Режим без присмотра",
  selectvehicletype: "Выберите тип транспортного средства",
  onlinevehicles: "Онлайн-транспортные средства",
  faultyvehicle: "Неисправные транспортные средства",
  presence: "Статус онлайн",
  initialization: "Инициализация",
  remotecontrolready: "Готов к дистанционному управлению",
  remotecontroldriving: "Дистанционное управление",
  manualintervention: "Ручное вмешательство",
  forcedlabor: "Принудительное ручное управление",
  clearwatervolume: "Объём чистой воды",
  sewagevolume: "Объём сточных вод",
  speeded: "Скорость",
  recentanomalies: "Последние аномалии",
  entrycontrol: "Контроль доступа",
  wakeup: "Пробуждение",
  wakeupsuccessfully: "Успешно пробуждено",
  wakeupfailed: "Ошибка пробуждения. Повторите попытку",
  awakening: "Пробуждение",
  userlist: "Список пользователей",
  enter: "Введите",
  enterphonenumber: "Введите номер телефона",
  selectcustomer: "Выберите клиента",
  allcustomers: "Все клиенты",
  selectagent: "Выберите агента",
  language: "Язык",
  selectlanguage: "Выберите язык",
  simplifiedchinese: "Упрощённый китайский",
  english: "Английский",
  german: "Немецкий",
  exceededwordlimit: "Превышен лимит символов. Повторите попытку",
  fillinyournamecorrectly: "Правильно укажите ваше имя",
  submittedsuccessfully: "Успешно отправлено",
  selectall: "Выбрать всё",
  enterphoneusername: "Поиск по номеру телефона / имени пользователя",
  newuser: "Создать пользователя",
  mobilephone: "Телефон",
  state: "Статус",
  enable: "Включить",
  disable: "Отключить",
  changesuccessful: "Успешно изменено",
  changefailed: "Ошибка изменения",
  confirmdisable:
    "Подтвердите отключение. Пользователь потеряет доступ к мини-приложению и мобильному приложению. Продолжить?",
  supportusernamesearch: "Поддержка поиска по имени пользователя",
  newusers: "Новые пользователи",
  lastlogintime: "Последний вход",
  administrator: "Суперадминистратор",
  admincannotbedeleted: "Нельзя удалить суперадминистратора",
  unattendedcontrol: "Управление в режиме без присмотра",
  metre: "Метр",
  supplymission: "Задача пополнения",
  returndockingpoint: "Возврат на стоянку",
  supportvinvehiclenamecustomer:
    "Поддержка поиска по VIN, названию ТС и клиенту",
  resourcestatistics: "Статистика ресурсов",
  successfullyset: "Успешно настроено",
  settingfailed: "Ошибка настройки",
  valuelimit: "Значение должно быть от 0 до 1440",
  vehicletype: "Тип транспортного средства",
  selectvehiclevin: "Выберите VIN транспортного средства",
  novehicleselected: "Транспортное средство не выбрано",
  selectstarttime: "Выберите время начала",
  switchdisplaymode: "Сменить режим экрана",
  enterworkstationnumber: "Введите номер устройства рабочей станции",
  newworkstation: "Создать рабочую станцию",
  equipmentnumber: "Номер устройства",
  enterdevicenumber: "Введите номер устройства",
  workstationname: "Название рабочей станции",
  forexample: "Например: 2-й этаж, северо-восточный угол, №1",
  adaptivevehiclemodel: "Совместимые модели ТС",
  enableornot: "Включить?",
  delayedrelease: "Задержка освобождения",
  channel: "Канал",
  occupy: "Занято",
  notavailable: "Недоступно",
  manualreset: "Ручной сброс",
  manualdrive: "Ручное управление",
  notaskmode: "Режим без задач",
  remotecontrolmode: "Режим дистанционного управления",
  mapcollection: "Сбор карт",
  pathcollection: "Сбор маршрутов",
  calibrationmode: "Режим калибровки",
  autonomousdrivingmode: "Режим автономного вождения",
  historicalpathmode: "Режим исторических маршрутов",
  gotospecialfunctionpoints: "Направиться к специальным точкам",
  paralleldriving: "Параллельное вождение",
  chargemode: "Режим зарядки",
  otanode: "OTA-узел",
  software: "Программное обеспечение",
  firmware: "Прошивка",
  voice: "Голос",
  automaticrecording: "Автоматическая запись",
  remoterecording: "Удалённая запись",
  manualrecording: "Ручная запись",
  uploaded: "Загружено",
  notuploaded: "Не загружено",
  normalend: "Нормальное завершение",
  shutdownended: "Завершено выключением",
  notfinished: "Не завершено",
  otanodes: "OTA-узлы",
  floorwashingvehiclesoftware: "ПО поломоечной машины",
  hardwareoffloorwashtruck: "Оборудование поломоечной машины",
  carwashvoice: "Голосовые подсказки поломоечной машины",
  passengercarsoftware: "ПО для легкового автомобиля",
  distributetovehiclemachine: "Отправить на бортовой компьютер",
  startdownloading: "Начать загрузку",
  downloadsuccessful: "Загрузка успешна",
  downloadfailed: "Ошибка загрузки",
  verificationsuccessful: "Проверка успешна",
  validationfailed: "Ошибка проверки",
  startupdating: "Начать обновление",
  updatefailed: "Ошибка обновления",
  updatesuccess: "Обновление успешно",
  pleaseupdatemapsource: "Ошибка проверки. Обновите версию ПО источника карты",
  Idlemode: "Режим простоя",
  mmode: "Ручной режим",
  others: "Прочее",
  nothave: "Нет",
  imuinitializationprogress: "Инициализация IMU",
  laserinitialization: "Инициализация лазера",
  mapsloading: "Загрузка карты",
  notstarted: "Не начато",
  underexecution: "В процессе выполнения",
  completed: "Завершено",
  abnormalend: "Аварийное завершение",
  paused: "Приостановлено",
  proactivelyending: "Принудительное завершение",
  created: "Создано",
  executed: "Выполнено",
  notexecutingontime: "Не выполнено вовремя",
  scheduledtaskdeleted: "Запланированная задача удалена",
  timedtaskstarttimechange: "Изменено время начала запланированной задачи",
  vehicleloadingothermaps: "Транспортное средство загружает другую карту",
  automaticsupply: "Автоматическое пополнение",
  userrole: "Роль пользователя",
  pleaseselectauserrole: "Выберите роль пользователя",
  messageswitch: "Переключатель уведомлений",
  on: "Вкл",
  off: "Выкл",
  number: "Количество персонала",
  rolemanagement: "Управление ролями",
  messagescope: "Диапазон получателей уведомлений",
  newroles: "Создать роль",
  accumulatedmachinerunningtime: "Общее время работы вентилятора",
  abstractccumulatedbatterycharginganddischargingtimes:
    "Общее количество циклов заряда/разряда аккумулятора",
  dutyhours: "Время дежурства",
  responsibleforthenumberofvehicles:
    "Количество закреплённых транспортных средств",
  newanomaly: "Сетевая аномалия",
  loopingtask: "Задача с петлёй",
  taskstatus: "Статус задачи",
  creating: "Создание",
  createdcomd: "Создание завершено",
  taskcreate: "Время создания задачи",
  funline: "Функциональная линия",
  loopboundaryline: "Граница петли",
  structuredroute: "Структурированный маршрут",
  systemfitting: "Аппроксимация системы",
  handdrawn: "Ручной ввод",
  expansionwidth: "Ширина расширения",
  segmenttype: "Тип сегмента",
  straightline: "Прямая",
  curve: "Кривая",
  directiontravel: "Направление движения",
  twowayroad: "Двустороннее движение",
  onewayroad: "Одностороннее движение",
  onewayroaddirection: "Направление одностороннего движения",
  fromstartend: "От начала к концу",
  fromendstart: "От конца к началу",
  mustclosed: "Обязательно наличие замкнутой области",
  mustloop: "Обязательно наличие границы петли",
  mustdirection: "Обязательно задание направления маршрута",
  map: "Карта",
  maplist: "Список карт",
  realtimemapupdates: "Обновление карты в реальном времени",
  mapssize: "Размер (м)",
  complete: "Завершить",
  mapedit: "Редактирование карты",
  funcpoint: "Функциональная точка",
  funcArea: "Функциональная зона",
  dockingpoint: "Точка стоянки",
  supplystation: "Станция пополнения",
  navigationpoint: "Навигационная точка",
  waitingpoint: "Точка ожидания лифта",
  mname: "Название",
  dummywall: "Виртуальная стена",
  accessdeviceid: "ID устройства контроля доступа",
  doorpointdist: "Расстояние до точки открытия двери",
  width: "Ширина",
  liftbrush: "Поднимать щётку при проходе",
  iswindshowerdoor: "Является ли дверь воздушным шлюзом",
  carpetarea: "Зона с ковром",
  nogozone: "Запретная зона",
  glassZone: "Зона со стеклом",
  slopearea: "Зона с уклоном",
  elevatorarea: "Зона лифта",
  dynamiczone: "Динамическая зона",
  warningarea: "Зона предупреждения",
  floorlamps: "Напольные светильники",
  brailleroad: "Тактильная дорожка",
  speedbumps: "Лежачий полицейский",
  radius: "Радиус",
  outmapedithing: "Редактирование не сохранено. Выйти?",
  limitnum20_300hint: "Ошибка ввода. Укажите значение от 20 до 300 см",
  limitnum150_500hint: "Ошибка ввода. Укажите значение от 150 до 500 см",
  limitnum20_200hint: "Ошибка ввода. Укажите значение от 20 до 200 см",
  limitnum5_50hint: "Ошибка ввода. Укажите значение от 5 до 50 см",
  inputlinetypehint: "Сначала выберите тип функциональной линии",
  inputpointtypehint: "Сначала выберите тип функциональной точки",
  inputearetypehint: "Сначала выберите тип функциональной зоны",
  inputenamehint: "Введите название",
  accessline: "Линия контроля доступа",
  checkdevicefailt: "Ошибка проверки ID устройства контроля доступа",
  accessorymodule: "Модуль аксессуаров",
  radicalladderentrymode: "Агрессивный режим входа в лифт",
  windshowerdoorswitch: "Переключатель воздушного шлюза",
  filterfunction: "Функция фильтрации",
  agvschedulingmode: "Режим диспетчеризации AGV",
  bindingdockingpoints: "Привязка точек стоянки",
  bindfloors: "Привязка этажей",
  copy: "Копировать",
  configuration: "Конфигурация",
  edithistory: "История редактирования",
  supportmapnamesearch: "Поддержка поиска по названию карты",
  editoperation: "Операция редактирования",
  editorialcontent: "Содержание редактирования",
  editingterminal: "Терминал редактирования",
  editor: "Редактор",
  edittime: "Время редактирования",
  confirmcopy: "Подтвердить копирование карты на транспортное средство",
  copymap: "Копировать карту",
  generatedsuccessfully: "Успешно сгенерировано",
  cancelbuild: "Отменить генерацию",
  cloud: "Облако",
  dendofcar: "Бортовое устройство",
  configurationsuccessful: "Конфигурация успешна",
  configurationfailure: "Ошибка конфигурации",
  new: "Новое",
  mixed: "Смешанный",
  configuring: "Конфигурирование",
  mapgeneration: "Генерация карты",
  generatedfailure: "Ошибка генерации",
  dataupdateinprogress: "Обновление данных",
  dataupdated: "Данные обновлены",
  dataupdateerror: "Ошибка обновления данных. Обновите страницу",
  workfrequency: "Общее количество запусков",
  siteinfo: "Информация о площадке",
  activitystatus: "Статус активации",
  activityed: "Активировано",
  lapseed: "Истекло",
  confirmresetactivity: "Подтвердить сброс активации",
  resetfailt: "Ошибка сброса",
  supply_internet_connect_offline:
    "Текущий режим рабочей станции — не общий. Нельзя добавить несколько станций",
  choiceWorkstation: "Выбрать рабочую станцию",
  confirmChoice: "Выберите корректную рабочую станцию",
  mouserighthint: "Подтвердите правой кнопкой мыши",
  savemapfailt: "Ошибка сохранения карты",
  canceledit: "Отменить редактирование",
  outpagetitle: "Покинуть страницу",
  systemnotsaveedit: "Система не сохранит изменения",
  saveediting: "Сохранение редактирования",
  gettaskpathing: "Генерация маршрута задачи",
  revoke: "Отменить",
  exit: "Выйти",
  choosedirection: "Выберите направление",
  clockwise: "По часовой стрелке",
  counterclockwise: "Против часовой стрелки",
  confirmexit: "Подтвердить выход?",
  savetimefailt: "Ошибка сохранения",
  failt: "Ошибка",
  changesleeptime: "Изменить время сна",
  sleeptimeerrorhint: "Должно быть целым числом от 900 до 86400 секунд",
  mouserightoverhint: "Завершить правой кнопкой мыши",
  liftareapointis4: "Зона лифта должна быть обозначена четырьмя точками",
  needhaveelevatorearehint:
    "Нельзя сохранить точку ожидания лифта без зоны лифта",
  waitelevatordis: "Продольное расстояние до точки ожидания лифта",
  numberLimt100_300Hint: "Ошибка ввода. Укажите значение от 100 до 300",
  numberLimt5_5Hint: "Ошибка ввода. Укажите значение от -5 до 5",
  waitelevatoroffsetdis: "Поперечное расстояние до точки ожидания лифта",
  hintreplacewaitingladderpoint: "Заменить существующую точку ожидания лифта?",
  dualopeningdoorelevator: "Лифт с двойными дверями",
  hintreplaceliftarea: "Заменить существующую зону лифта?",
  opendirection: "Направление открытия дверей на этом этаже",
  direction: "Прямое",
  oppositedirection: "Обратное",
  cantsavewaitelevatorpointhint:
    "Нельзя сохранить точку ожидания лифта без указания направления дверей",
  edgebrushpresslow: "Низкое давление боковой щётки",
  edgebrushpressmedium: "Среднее давление боковой щётки",
  edgebrushpresshigh: "Высокое давление боковой щётки",
  planning: "Планирование",
  location: "Позиционирование",
  perceive: "Восприятие",
  inputoutmaxmin: "Ввод вне допустимого диапазона",
  idlecharge: "Порог автоматической зарядки в простое",
  boundarycrossings: "Невозможно сохранить из-за пересечения границ",
  cannotadded: "Невозможно добавить",
  locationpointnotlegal: "Некорректная точка позиционирования",
  airshowertime: "Время воздушного шлюза",
  inputairshowertime: "Ошибка ввода. Укажите значение от 0 до 300",
  cantcompletearea: "Неполная функциональная зона. Невозможно завершить",
  cantcompleteline: "Неполная функциональная линия. Невозможно завершить",
  saveing: "Сохранение",
  careditingparamhint: "Параметр редактируется. Повторите позже",
  careditingmap: "Карта редактируется на транспортном средстве",
  cannotbeadecimalnumber: "Не может быть дробным числом",
  repeataddvinhint: "Транспортное средство уже существует",
  fulled: "Полностью заряжено",
  themaximumis: "Максимум",
  theminimumis: "Минимум",
  freeornot: "Свободно?",
  deleteornot: "Удалить?",
  mapshow: "Предпросмотр карты",
  tasklist: "Список задач",
  createtask: "Создать задачу",
  linename: "Название маршрута",
  addtask: "Добавить задачу",
  addfunpoint: "Добавить функциональную точку",
  rename: "Переименовать",
  low: "Низкий",
  intermediate: "Средний",
  high: "Высокий",
  onekeycombination: "Комбинация в один клик",
  ordinarytask: "Обычная задача",
  teachingtask: "Обучающая задача",
  teachautofill: "Автозаполнение по обучению",
  teachpolygonfilling: "Заполнение многоугольника по обучению",
  handautofill: "Автозаполнение по ручному вводу",
  freehandpolygonfilling: "Заполнение многоугольника вручную",
  fullcoverageofteaching: "Полное покрытие по обучению",
  handpaintedfullcoverage: "Полное покрытие вручную",
  unbound: "Без привязки",
  tasknamespecification:
    "Поддержка 1–20 символов: китайские/латинские буквы, цифры",
  followtherules: "Введите название задачи по правилам",
  isitcreatedasacombinationtask: "Создать как комбинированную задачу?",
  whethertodeletethispathtask: "Удалить этот маршрут?",
  selecttasktype: "Выберите тип задачи",
  filemanagement: "Управление файлами",
  terminalcatalog: "Каталог на транспортном средстве",
  currentstate: "Текущий статус",
  pleaseconfirmcarefully: "Убедитесь, что каталог указан верно",
  selectfile: "Выберите файл",
  unuploadedfile: "Файл не загружен",
  confirmuploadandpublish: "Подтвердить загрузку и публикацию",
  nofilehasbeenuploaded: "Нет загруженных файлов. Публикация невозможна",
  terminaldirectoryisnotfilledin:
    "Не указан каталог на ТС. Публикация невозможна",
  nopushvehicleselected: "Не выбраны ТС для отправки",
  entertheterminaldirectory: "Укажите каталог на транспортном средстве",
  confirmrelease: "Подтвердить публикацию?",
  pleaseenterthefilename: "Введите имя файла / оператора",
  vehicleoffline: "Транспортное средство офлайн",
  succeededinsendinginstruction: "Команда успешно отправлена",
  customcleaning: "Пользовательская уборка",
  quickcombinationtask: "Быстрая комбинированная задача",
  ordinarycombinedtask: "Обычная комбинированная задача",
  sort: "Классификация",
  manualrealtimefullcoverage: "Ручное полное покрытие в реальном времени",
  teachingrealtimefullcoverage: "Обучающее полное покрытие в реальном времени",
  freehandline: "Линия, нарисованная вручную",
  newelevator: "Создать лифт",
  placedeviceName: "Введите название устройства",
  placeinputbuildinginformation: "Введите информацию о здании",
  placeinputmanufacturer: "Введите название производителя",
  placeinputchannel: "Введите номер канала",
  placeinputadress: "Введите адрес",
  placeinputfloor: "Введите количество этажей",
  reachable: "Этаж доступен",
  floorname: "Название этажа",
  floornumble: "Количество этажей",
  confirmwanttowakevehicle: "Подтвердить пробуждение ТС?",
  whethertosavethecombinedtask: "Сохранить комбинированную задачу?",
  failedtocreatecombinationtask: "Ошибка создания комбинированной задачи",
  pleaseselectmap: "Выберите карту",
  creatingacompositetask: "Создание комбинированной задачи",
  thetaskpathcannotbeempty: "Маршрут задачи не может быть пустым",
  theoneclickcombinationsucceeded: "Комбинация в один клик успешна",
  oneclickcombinationfailed: "Ошибка комбинации в один клик",
  deletehandfilleare: "Удалить область, заполненную вручную?",
  savehandfilleare: "Сохранить область, заполненную вручную?",
  nameexistsrenameit: "Название уже существует. Переименуйте",
  cantsavetask: "Задача выполняется на ТС. Сохранение невозможно",
  redeliveryfailure: "Ошибка повторной отправки",
  carisinediting: "Задача редактируется на ТС",
  tasksavingfailure: "Ошибка сохранения задачи",
  failedgetdetails: "Ошибка получения деталей",
  whethertocancel: "Отменить операцию?",
  whethertodeletethetaskpath: "Удалить маршрут задачи?",
  whethertosubmit: "Подтвердить отправку?",
  cannotbeempty: "Не может быть пустым",
  yuefan: "Yuefan",
  pleaseenternumber: "Введите число",
  rechargethreshold: "Порог пополнения",
  rechargechargingthreshold: "Порог зарядки при пополнении",
  rechargewaterthreshold: "Порог уровня чистой воды при пополнении",
  rechargeeffluentthreshold: "Порог уровня сточных вод при пополнении",
  labelclassification: "Метка версии",
  frametype: "Модель шасси",
  carversionnumber: "Текущая версия",
  upgradeversioninfo: "Информация об обновлении версии",
  upgradetime: "Время обновления",
  numberofupgrades: "Количество обновлений",
  versionupgrademanagement: "Управление обновлениями версий",
  creatingupgradetask: "Создать задачу обновления",
  upgradetag: "Метка обновления",
  linkthestudgroup: "Привязать группу DingTalk",
  studgrouplink: "Укажите ссылку на группу DingTalk",
  upgrades: "Обновления",
  deleteselectedvehicle:
    "Удалить? После удаления уведомления о выходе ТС в сеть прекратятся",
  operators: "Оператор",
  studgroupmessage: "Сообщение в группу DingTalk",
  enterpromptcopy: "Введите текст уведомления",
  enterfullinformation: "Заполните все поля перед отправкой",
  cancelthenewlycreated: "Отменить создание?",
  editcurrentversion: "Редактировать текущую версию",
  commitfailure: "Ошибка отправки",
  manualupgrade: "Ручное обновление",
  upgradesuccessfully: "Обновление успешно",
  upgradefailure: "Ошибка обновления",
  whethertodeliveragain: "Подтвердить повторную отправку?",
  upgradetype: "Тип обновления",
  minimumcompatibleversion: "Минимальная совместимая версия",
  promptfrequency: "Частота напоминаний",
  forcedupgrade: "Принудительное обновление",
  strongpromptescalation: "Сильное напоминание об обновлении",
  weakpromptupgrade: "Слабое напоминание об обновлении",
  noupgradeprompt: "Без напоминаний",
  silentscalation: "Тихое обновление",
  unfilledsubmit: "Не все поля заполнены!",
  eachprompt: "Проверять при каждом разблокировании экрана ТС",
  promptonlyonce: "Напоминать только три раза",
  operationtype: "Тип операции",
  editequipment: "Редактировать устройство",
  carend: "Бортовое устройство",
  cloudbased: "Облачное",
  operatingusers: "Пользователь",
  operationtime: "Время операции",
  operationlist: "Список операций",
  alarmmonitoring: "Мониторинг оповещений",
  newalarmfault: "Настройка параметров оповещений",
  downloadform: "Скачать форму",
  faulttype: "Тип неисправности",
  alarmdescription: "Описание оповещения",
  occurrencefrequency: "Частота возникновения",
  timeoffailure: "Время неисправности",
  minimumthreshold: "Минимальный порог длительности",
  frequencyofoccurrence: "Количество случаев",
  selectafaulttypetomonitor: "Выберите тип неисправности для мониторинга",
  collide: "Срабатывание за период",
  vehiclecollision: "Столкновение транспортного средства",
  poorcondition: "Плохое качество позиционирования",
  lowbatteryreminder: "Напоминание о низком заряде",
  viewrecord: "Просмотреть запись",
  durationofoccurrence: "Продолжительность события",
  maperrbasepointhint:
    "Ошибка данных исходной точки карты. Редактирование невозможно",
  namerepater: "Название повторяется",
  elevatorweight: "Приоритет лифта",
  elevatorweightwarn: "Примечание: чем выше число, тем выше приоритет лифта",
  elevatordetail: "Детали лифта",
  bindelevtorselect: "Выберите лифт для привязки",
  noelevator: "Нет доступных лифтов для привязки",
  needbindelevatorhint: "Выберите связанный лифт",
  intherequest: "Запрос выполняется...",
  bindelevatorname: "Название связанного лифта",
  needunbindmapfloor: "Сначала отвяжите этаж от карты",
  cancelwillnotsave: "Отмена отменит все изменения",
  datasynchronization: "Синхронизация данных",
  datasynchronizationfailed: "Ошибка синхронизации. Повторите попытку",
  driveoutofthemap: "Выезд за пределы карты",
  remoteconnection: "Удалённое подключение",
  tasknameandinfo: "Название и информация о задаче",
  taskcreator: "Создатель задачи",
  taskprogress: "Прогресс задачи",
  timedreplenishment: "Запланированное пополнение",
  idlesupply: "Пополнение в простое",
  thresholdrecharge: "Пополнение по порогу",
  underway: "В процессе",
  finish: "Завершено",
  taskfailure: "Задача не выполнена",
  unclean: "Не убрано",
  cleaned: "Убрано",
  exporttaskreport: "Экспорт отчёта по задаче",
  basicinfo: "Основная информация",
  tasklog: "Журнал задачи",
  pleaseenterkeyword: "Введите ключевое слово",
  start: "Начать",
  supplytrigger: "Триггер пополнения",
  supplymissionhasended: "Задача пополнения завершена",
  supplymissionconstruction: "Формирование задачи пополнения",
  headtothesupplystation: "Направляется к станции пополнения",
  pilealignment: "Выравнивание по станции",
  retreatthepile: "Отъезд от станции",
  constructionofthestopoverpointtask: "Формирование задачи стоянки",
  headtothestopoverpoint: "Направляется к точке стоянки",
  thestopoverpointmissionhasended: "Задача стоянки завершена",
  buildtheladdercrossingtask: "Формирование задачи перехода между этажами",
  headtothewaitingpoint: "Направляется к точке ожидания лифта",
  entertheelevator: "Вход в лифт",
  exittheelevator: "Выход из лифта",
  thestaircrossingtaskisover: "Задача перехода между этажами завершена",
  combinedtaskconstruction: "Формирование комбинированной задачи",
  thecleaningtaskbegins: "Начало уборки",
  thecleaningtaskhasbeensuspended: "Уборка приостановлена",
  thecleaningtaskcontinues: "Уборка возобновлена",
  thecleaningtaskisover: "Уборка завершена",
  earlywatercutoff: "Досрочное отключение воды",
  restoreparametersexittheribbon:
    "Восстановление параметров — выход из функциональной зоны",
  waterabsorptionwhilemoving: "Всасывание при движении",
  thewatercollectiontaskiscompleted: "Задача сбора воды завершена",
  delayedsuction: "Задержка всасывания",
  accesscontrolreservation: "Бронирование контроля доступа",
  headtotheaccesscontrolpoint: "Направляется к точке контроля доступа",
  completedthroughaccesscontrol: "Проход через контроль доступа завершён",
  multifloortaskconstruction: "Формирование многоэтажной задачи",
  multifloorcombinedtaskconstruction:
    "Формирование комбинированной многоэтажной задачи",
  themultifloorcleaningtaskhasbegun: "Началась многоэтажная уборка",
  themultifloorcleaningtaskhasbeensuspended:
    "Многоэтажная уборка приостановлена",
  themultifloorcleaningtaskcontinues: "Многоэтажная уборка возобновлена",
  themultifloorcleaningtaskhasbeencompleted: "Многоэтажная уборка завершена",
  thetaskloopbegins: "Цикл задачи начат",
  restartsuccessfully: "Транспортное средство успешно запущено",
  vehiclefailedtostart: "Ошибка запуска транспортного средства",
  parkingplacetotalnumber: "Общее количество парковочных мест",
  parkingplacecleanablenumber: "Количество убираемых парковочных мест",
  parkingplacecleanednumber: "Количество убранных парковочных мест",
  parkingplaceuncleanednumber: "Количество неубранных парковочных мест",
  cantclean: "Не подлежит уборке",
  nosupplementarytasks: "Нет задач пополнения",
  usermanuallyissuesthesupplytask:
    "Пользователь вручную назначил задачу пополнения",
  lowbatterytriggersthenationalvaluetask:
    "Низкий заряд вызвал задачу по порогу",
  thelowwaterleveltriggersthethresholdtask:
    "Низкий уровень воды вызвал задачу по порогу",
  whenthesewageisfull: "Полный бак сточных вод вызвал задачу по порогу",
  thresholdtask: "Простой ТС вызвал задачу по порогу",
  thresholdtasklowbattery: "Простой ТС вызвал задачу по порогу — низкий заряд",
  resholdtaskclearwaterthreshold:
    "Простой ТС вызвал задачу по порогу — уровень чистой воды",
  thresholdtasksewagethreshold:
    "Простой ТС вызвал задачу по порогу — уровень сточных вод",
  thresholdtaskdustbag: "Простой ТС вызвал задачу по порогу — пылесборник",
  withoutspecifyingsupplystations:
    "Пользователь назначил задачу пополнения без указания станции",
  thebatteryvoltagedifferenceisconstant:
    "Аномальная разница напряжений в аккумуляторе",
  supplysubtaskscheduling: "Планирование подзадач пополнения",
  timedsupplyrequestsaremadetothecloud:
    "Запрос запланированного пополнения отправлен в облако",
  userended: "Завершено вручную",
  prepareforfailure: "Ошибка подготовки",
  afterthetaskispausedproceedmanually: "После паузы перейти в ручной режим",
  userskips: "Пользователь пропустил",
  gotothesupplystationafterthemissionissuspended:
    "После паузы направиться к станции пополнения",
  thetaskshutdownhasended: "Задача завершена выключением",
  reachthemandatoryendtime: "Достигнуто время принудительного завершения",
  thetaskescapefailedwithinthelimitedtime:
    "Не удалось выйти из затруднения за отведённое время",
  thedelayedwaterabsorptiondistanceissufficient:
    "Пройдено достаточное расстояние для задержки всасывания",
  allareashavebeencleaned: "Вся площадь убрана",
  thedockedtaskhastimedout: "Задача выравнивания по станции превысила время",
  thepathplanningforthetasksadvanceschedulingfailed:
    "Ошибка планирования маршрута при предварительной диспетчеризации",
  theescapenearthefinishlinefailed:
    "Не удалось выйти из затруднения рядом с финишем",
  communicationatthefieldendfailed: "Ошибка связи с сервером",
  theescapefailedRequesttoendthetaskimmediately:
    "Не удалось выйти из затруднения. Запрос немедленного завершения",
  returnimmediatelyandend: "Немедленный возврат и завершение",
  remotesoftrestart: "Удалённая мягкая перезагрузка",
  successfullyjumpedoutofthepredicament:
    "Успешный выход из затруднения через прыжок",
  rotationalrepositioning: "Повторное позиционирование с поворотом",
  skipatlowwaterlevel: "Пропуск при низком уровне воды",
  therollerbrushidlestemporarilytoendthetask:
    "Временное завершение из-за холостого хода валика",
  thecrossfloormissionfailed: "Ошибка многоэтажной задачи",
  thevehiclecrossesthedoor: "Транспортное средство пересекло дверь",
  taskstatusjumpstotaskrecovery: "Изменение статуса задачи — восстановление",
  thewatercollectionoperationhasbeencompletelycompleted:
    "Операция сбора воды полностью завершена",
  theuserrequeststoendthetask:
    "Пользователь запросил завершение, но требуется завершить сбор воды",
  nodefailureoccurred: "Произошла ошибка узла",
  conflictswiththesupplystationmission:
    "Конфликт между задачей задержки всасывания и задачей пополнения",
  accesscontrolreservationfailed: "Ошибка бронирования контроля доступа",
  doorpassagetimeout: "Превышено время прохода через дверь",
  thepedalisdepressedandthetaskisover: "Задача завершена нажатием педали",
  thewiringharnessconnectionatthesupplystationisabnormal:
    "Аномальное подключение кабеля на станции пополнения",
  repositioninginthefirststageofsupply:
    "Повторное позиционирование на первом этапе пополнения",
  thescheduledtaskbeginstobeexecuted:
    "Началось выполнение запланированной задачи",
  canceltheelevatorcontroltaskinthecloud:
    "Облако отменило задачу управления лифтом",
  theelevatordoorwassuccessfullyfedbackfromthebottomlayer:
    "Успешный сигнал открытия дверей лифта с нижнего этажа",
  thesewagedischargeisseriouslyabnormal: "Серьёзная аномалия слива сточных вод",
  thevehiclecrossedthenarrowgate:
    "Транспортное средство прошло через узкие ворота",
  thevehiclecrossedtheladderagain:
    "Транспортное средство повторно перешло между этажами",
  Thelastsubtaskisoverandthefollowupisover:
    "Последняя подзадача завершена, завершение последующих",
  thereisnocrossfloorpath: "Нет маршрута между этажами",
  thesupplymeetsthethreshold: "Пополнение соответствует порогу",
  usermanualpause: "Пользователь вручную приостановил",
  cloudrequestpause: "Облако запросило паузу",
  switchtomanualpause: "Переключение в ручную паузу",
  thethresholdtriggersthepause: "Порог вызвал паузу",
  thesupplymissionhasbeensuspended: "Задача пополнения приостановлена",
  lowerthepedalandpause: "Пауза при опускании педали",
  locationlosspause: "Пауза из-за потери позиционирования",
  theshutdowneventissuspended: "Пауза из-за события выключения",
  thepositioningjumptemporarilysuspendsthetask:
    "Временная пауза из-за скачка позиционирования",
  exitpause: "Пауза при проходе через дверь",
  thedistanceinthefirststageofdelayedwaterabsorptionissufficient:
    "Пройдено достаточное расстояние на первом этапе задержки всасывания",
  rgbddetectiontriggered: "Сработало обнаружение RGBD",
  pausewhenpassingthroughthefunctionarea:
    "Пауза при проходе через функциональную зону",
  cloudbaseddispatchto: "Облачная диспетчеризация направляет к",
  thevehicleisidleandheadingtotheparkingpoint:
    "ТС в простое направляется к точке стоянки",
  thesupplymissionhasbeencompleted:
    "Задача пополнения завершена. Требуется направиться к точке стоянки",
  requestingcloudsupplies:
    "Запрос пополнения в облаке. Требуется направиться к точке стоянки",
  thethresholdtriggersthenofeedstation:
    "Порог вызвал отсутствие станции пополнения. Направиться к точке стоянки",
  thesupplycommunicationfailed:
    "Ошибка связи при пополнении. Возврат к точке стоянки",
  failedtogetoutoftroublewithsupplies:
    "Не удалось выйти из затруднения при пополнении. Возврат к точке стоянки",
  failedtocrossthestairs:
    "Не удалось перейти между этажами. Возврат к точке стоянки",
  themultifloortaskcontrolhasended:
    "Управление многоэтажной задачей завершено. Пользователь запросил возврат к точке стоянки",
  taskassignment: "Назначение задачи",
  theoperator: "Оператор",
  taskpowerconsumption: "Потребление энергии задачей",
  parkingcyclenum: "Количество уборок парковки",
  lanecyclenum: "Количество уборок полосы",
  noparkingspacetoclean: "Нет парковочных мест для уборки",
  theescapefromthefinishlinefailed: "Не удалось выйти из затруднения у финиша",
  inanimpassablearea: "Начальная точка ТС в непроходимой зоне",
  thepedalwassteppedon: "Педаль нажата",
  communicationfailure: "Ошибка связи",
  pilealignmentfailed: "Ошибка выравнивания по станции",
  thechargerisnotconnected: "Зарядное устройство не подключено",
  thesupplystationtask:
    "Пользователь вручную завершил задачу станции пополнения",
  theoperationofcleaningthesewagetankisabnormal:
    "Аномальная операция очистки бака сточных вод",
  thefreshwatertankisabnormal:
    "Аномальная операция опорожнения бака чистой воды",
  theoperationofaddingwatertothefreshwatertankisabnorma:
    "Аномальная операция наполнения бака чистой воды",
  communicationinterruption: "Обрыв связи",
  accidentaldetachmentofthepost: "Случайное отключение от станции",
  thesewagetankonthesiteisfull: "Бак сточных вод на площадке полон",
  thethresholdparameterisabnormal: "Аномальные пороговые параметры",
  automaticreplenishmentcompleted: "Автоматическое пополнение завершено",
  thereplenishmenthasbeencompleted: "Пополнение чистой воды завершено",
  replenishmenthavebeencompleted: "Очистка бака сточных вод завершена",
  thewaterleveloftheaddedclearwaterisabnormal:
    "Аномальный уровень добавленной чистой воды",
  abnormalwaterlevelofdrainagesewage:
    "Лёгкая аномалия уровня сточных вод при сливе",
  therechargeablebatterycapacityisabnormal: "Аномальная ёмкость аккумулятора",
  theliquidlevelswitchofthesewageboxatthepileendisabnormal:
    "Аномальный датчик уровня в баке сточных вод на станции",
  thewaterlevelofthesewageatthepileendisabnormal:
    "Аномальный уровень сточных вод на станции",
  thesewageattheendofthefieldisfull: "Бак сточных вод на площадке полон",
  abnormalelectrodetemperature: "Аномальная температура электродов",
  thehubtemperatureisabnormal: "Аномальная температура ступицы",
  thewaterlevelofthedrainagesewageisabnormalserious:
    "Серьёзная аномалия уровня сточных вод при сливе",
  abnormalwaterlevelofdrainagesewageignored:
    "Игнорирование аномалии уровня сточных вод",
  chargerfailure: "Неисправность зарядного устройства",
  needtogotothestopoverpoint:
    "Задача завершена, требуется пополнение, но станции нет — направиться к точке стоянки",
  whetherthedrainageofthefreshwatertankhasbeencompleted:
    "Опорожнение бака чистой воды завершено",
  normalplanningfailure: "Ошибка обычного планирования",
  thestartingpointofthevehicleisamongtheobstacles:
    "Начальная точка ТС в зоне препятствий",
  thefinishlineisamongtheobstacles: "Финиш в зоне препятствий",
  thetargetpointisunreachable: "Целевая точка недостижима",
  thestartingpointofthevehicleisinthevirtualwall:
    "Начальная точка ТС в зоне виртуальной стены",
  thedestinationisinthevirtualwall: "Финиш в зоне виртуальной стены",
  therearenogeneratedpathsinfullcoverage: "Нет маршрутов для полного покрытия",
  functionalareacontinues: "Продолжение после функциональной зоны",
  endtask: "Завершить задачу",
  endcurrenttask: "Завершить текущую задачу?",
  endtaskfailed: "Ошибка завершения задачи",
  waitingforvehicleagreementloading:
    "Ожидание подтверждения удалённого управления от ТС",
  waitingforvehicleagreement: "Ожидание удалённого управления",
  exitremotecontrol: "Выйти из удалённого управления",
  remotecontrol: "Удалённое управление",
  exitremotecontrolsuccess: "Удалённое управление завершено",
  remotecontrolconnectedsuccessfully:
    "Подключение к удалённому управлению успешно",
  sendtaskfailed: "Ошибка отправки задачи",
  taskpausefailed: "Ошибка приостановки задачи",
  checkremotestatusfailed: "Ошибка проверки статуса удалённого управления",
  starttaskfailed: "Ошибка запуска задачи",
  taskstart: "Начать",
  taskend: "Завершить",
  taskpause: "Приостановить",
  taskcontinue: "Продолжить",
  otherremotectrl: "Уже управляется другим клиентом",
  vehiclerefusecontrol: "ТС отклонило запрос удалённого управления",
  notinremotectrl: "Не в режиме удалённого управления",
  taskcarline: "Проверьте, подключено ли ТС",
  requestremotectrlfailed: "Ошибка запроса управления. Повторите позже",
  vehicleonline: "Невозможно управлять удалённо. Проверьте статус ТС",
  tasklisttitle: "Список задач",
  exitremotecontrolfailed:
    "Ошибка выхода из удалённого управления. Повторите позже",
  scheduledtask: "Запланированная",
  covered_area: "Площадь уборки",
  covered_aream2: "Площадь уборки",
  minute1: "Мин",
  second1: "Сек",
  mobilephonesnapshot: "Снимок с мобильного телефона",
  semanticrecognition: "Семантическое распознавание",
  supplyrecord: "Журнал пополнений",
  unlocksuccess: "Успешно открыто",
  closedsuccessfully: "Успешно закрыто",
  fallproof: "Защита от падения",
  scancodestart: "Запуск сканирования",
  times: "раз",
  toupgrade: "Ожидает обновления",
  Upgraded: "Обновлено",
  droppoint: "Точка падения",
  highconfidenceregion: "Зона высокой достоверности",
  narrowaisles: "Узкие проходы",
  intotal: "Всего",
  article: "строчка",
  wxb: "Облачная платформа управления WoXiaoBai",
  pleaseenteraccountnumber: "Введите логин",
  makecleaningeasy: "WoXiaoBai·чистота проще",
  corporation: "ООО Пекинская технологическая компания “Чжисинчжэ”",
  notauserofthisplatform: "Внешний пользователь",
  pleaseentervenueinformation: "Введите информацию о месте",
  remark: "Комментарий",
  edituser: "Редактирование пользователя",
  taskdetails: "Подробности задачи",
  vehicles: "Транспортные средства",
  totalDevices: "Всего устройств",
  onlineDevices: "Онлайн устройств",
  cleaningArea: "Площадь уборки",
  operatingCleaningTime: "Время работы уборки",
  operatingCleaningArea: "Площадь работы уборки",
  days7: "7 дней",
  days30: "30 дней",
  days90: "90 дней",
  tasksuccesscount: "Количество успешных задач",
  taskabnormalcount: "Количество аномальных задач",
  taskTotalCount: "Всего задач",
  faultstatistics: "Статистика неисправностей",
  powerconsumption: "Потребление электроэнергии",
  cleaningEfficiencyStatistics: "Статистика эффективности уборки",
  maxCleaningEfficiency: "Максимальная эффективность уборки",
  cleaningEfficiency: "Эффективность уборки",
  taskEndNormal: "Нормальное завершение",
  taskEndAbnormal: "Аномальное завершение",
  taskEndPreparationFail: "Ошибка подготовки",
  taskEndSupply: "Пополнение",
  taskEndShutdown: "Выключение",
  taskEndLocalizationFail: "Ошибка позиционирования",
  taskEndRescueTimeout: "Тайм-аут спасения",
  taskEndGlobalPathFail: "Ошибка глобального пути",
  taskEndDispatchPathFail: "Ошибка пути диспетчеризации",
  taskEndNearGoalRescueFail: "Ошибка спасения у цели",
  taskEndLowWaterSkip: "Пропуск при низком уровне воды",
  taskEndCrossFloorFail: "Ошибка перехода между этажами",
  taskEndNodeFault: "Ошибка узла",
  taskEndPedalPressed: "Педаль нажата",
  taskEndSewageAbnormal: "Аномалия сточных вод",
  taskEndTargetUnreachable: "Цель недостижима",
  taskEndStartInVirtualWall: "Запуск в виртуальной стене",
  taskEndUnknown: "Неизвестно",
};
